import React, { ReactNode, useEffect, useState } from "react";
import { IPrefeitura } from "../../../Hooks/usePrefeitura";
import { AddLigacaoPrefeitura } from "../../AddLigacaoPrefeitura";

import { Container } from "./styles";
interface Props {
  item: IPrefeitura;
  children: ReactNode;
}

export function LigacaoPrefeituraButton({ item, children }: Props) {
  const [open, setOpen] = useState(false);
 
  return (
    <>
      <Container
        onClick={() => {
          setOpen(true);
        }}
      >
        {children}
      </Container>
      <AddLigacaoPrefeitura
        open={open}
        onClose={() => setOpen(false)}
        item={item}
        key={item.ID}
      
      />
    </>
  );
}
